// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-sort-unsorted
 * @tagname hzn-icon-sort-unsorted
 * @summary An individual icon for Horizon
 */
export class HznIconSortUnsorted extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.97732 16.3621L1.41421 14.799L0 16.2132L3.27013 19.4833C3.66066 19.8739 4.29382 19.8739 4.68435 19.4833L7.95448 16.2132L6.54027 14.799L4.97732 16.3619V0H2.97732L2.97732 16.3621ZM13.2702 3.41432V19.7761H11.2702V3.41414L9.70712 4.97726L8.2929 3.56304L11.563 0.29291C11.9536 -0.0976147 12.5867 -0.0976147 12.9772 0.29291L16.2474 3.56304L14.8332 4.97726L13.2702 3.41432Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=sort-unsorted.js.map